import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { InitScripts } from './app.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'
  ]
})
export class AppComponent implements OnInit {
  year = (new Date()).getFullYear();

  constructor(private appService: AppService) {
    this.appService.post();
  }

  logoSrc = "../assets/images/Sarvadhnya2.jpg";
  i = false;
  autoSaveInterval = setInterval(() => {
    if (this.i) {
      this.logoSrc = "../assets/images/Sarvadhnya2.jpg";
    }
    else {
      this.logoSrc = "../assets/images/Sarvadhnya1.jpg";
    }
    this.i = !this.i;
  }, 5000);

  ngOnInit() {
    new InitScripts().loadScripts();
  }

  public closeMenu() {
    var element = document.getElementById("navbar");
    element?.classList.remove('navbar-mobile');
    var clild = element?.querySelector(".mobile-nav-toggle");
    clild?.classList.replace("bi-x", "bi-list");
    window.scrollTo(0, 0);
  }


}

